module.exports = __webpack_public_path__ + "02_bob_brown.3fed30f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/02_bob_brown.png
// module id = ev0F
// module chunks = 0